import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www-local/frontend/lides/lides-sk-01/app/components/product/card/ProductCard.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www-local/frontend/lides/lides-sk-01/app/components/product/ProductsListAnalytics.jsx");
;
import(/* webpackMode: "eager" */ "/var/www-local/frontend/lides/lides-sk-01/components/_other/button/Button.module.scss");
;
import(/* webpackMode: "eager" */ "/var/www-local/frontend/lides/lides-sk-01/components/carousels/Carousel.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www-local/frontend/lides/lides-sk-01/components/carousels/MainBanner.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www-local/frontend/lides/lides-sk-01/components/forms/newsletter/NewsletterForm.js");
;
import(/* webpackMode: "eager" */ "/var/www-local/frontend/lides/lides-sk-01/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/var/www-local/frontend/lides/lides-sk-01/node_modules/next/dist/client/image-component.js");
